import { createSpreadableBem } from "/Helpers/createBem";
import "./FactsSidebarBlock.scss";
import {
  OptimizelyEditProperty,
  Picture,
  ContentArea,
  InfoSmallIcon,
} from "/App.Components";
import { FactsSidebarBlockProps } from "/Models/Generated/FactsSidebarBlockProps";

const FactsSidebarBlock = ({
  heading,
  headingPropertyName,
  image,
  imagePropertyName,
  text,
}: FactsSidebarBlockProps) => {
  const bem = createSpreadableBem("facts-sidebar-block");
  return (
    <aside {...bem("")}>
      <OptimizelyEditProperty propertyName={headingPropertyName}>
        {heading && <h2 {...bem("__heading")}>{heading}</h2>}
      </OptimizelyEditProperty>
      <OptimizelyEditProperty propertyName={imagePropertyName}>
        {image && (
          <div {...bem("__image-container")}>
            <Picture {...image} pictureBehaviour="FullWidth" />
            {(image?.imageText || image?.copyright) && (
              <div {...bem("__image-text-container")}>
                {image?.imageText && (
                  <p {...bem("__image-text")}>{image.imageText}</p>
                )}
                {image?.copyright && (
                  <div {...bem("__copyright-container")}>
                    <InfoSmallIcon text={image.copyright} />
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </OptimizelyEditProperty>
      {text && (
        <ContentArea
          {...text}
          richText={{ theme: "factssidebar", breakWord: true }}
        />
      )}
    </aside>
  );
};

export default FactsSidebarBlock;
